import React, { useEffect, useState } from 'react';
import walletService from './payService';
import './css/WalletContent.css';
import authService from '../auth/authService';
import labService from '../lab/labService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import HashLoader from "react-spinners/HashLoader";
import { IoCheckmarkOutline } from 'react-icons/io5';

const WalletContent = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: 'created', direction: 'descending' });
    const [payments, setPayments] = useState([]);
    const [histLoading, setHistLoading] = useState(true);
    
    // CHANGED: selectedAmount changed to selectedLicense
    const [selectedLicense, setSelectedLicense] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        const user = authService.getCurrentUser();
        setCurrentUser(user);
    }, []);

    useEffect(() => {
        if (currentUser) {
            walletService.listPayments(currentUser.access).then(response => {
                console.log(response.data)
                setPayments(response.data);
                setHistLoading(false)
            }).catch(error => {
                console.error(error);
                setHistLoading(false);
            });
        }
    }, [currentUser]);

    // CHANGED: Now accepts licenseType instead of amount
    const handlePurchase = async (licenseType) => {
        try {
            const token = currentUser.access
            const data = await walletService.purchaseTokens(token, licenseType);
            window.location.href = data.url;
        } catch (error) {
            console.error('Error during purchase:', error);
        }
    };

    const sortedPayments = [...payments].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIndicatorClass = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? 'ascending' : 'descending';
        }
        return '';
    };

    // CHANGED: Replaced 'amount' with 'license_type' matching the Django dictionary keys
    const licenses = [
        { title: 'One nanoform', sub: 'specific endpoints', price: '99.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test one nanoform', 'Choose only endpoints you need'], license_type: 'nano_specific' },
        { title: 'One nanoform', sub: 'all endpoints', price: '2999.00', note: 'for all endpoints', perks: ['Test one nanoform', 'Test all endpoints available for one Nanoform'], license_type: 'nano_all' },
        { title: 'One substance', sub: 'all endpoints', price: '15081.00', info: 'Starts with', perks: ['Test as many nanoforms as you want', 'Test all endpoints available for Substance'], license_type: 'substance_all' },
        { title: 'Many nanoforms', sub: 'specific endpoints', price: '499.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test as many nanoforms as you want', 'Choose only endpoints you need', 'Valid for 12 months'], license_type: 'many_specific' },
    ];

    return (
        <main className="main-wrapper">
            <div className="user-licenses">
                <header className="license-header">
                    <h2 className='h2-title'>Your licenses</h2>
                    <div className="status-container">
                        <span className="dot"></span>
                        <p>You have active licenses</p>
                    </div>
                </header>

                <div className="license-grid">
                    {licenses.map((item, index) => (
                        <div key={index} className="license-card">
                            <div className="card-title">
                                <strong>{item.title}</strong><span className="green-text">/ {item.sub}</span>
                            </div>
                            <div className="price-box">
                                {item.info && <span className="price-info">{item.info}</span>}
                                <div className="price-main">
                                    <span className="currency">€</span>
                                    <span className="amount">{item.price}</span>
                                    {item.note && <span className="price-note">{item.note}</span>}
                                </div>
                            </div>
                            <div className='perk-container'>
                                <ul className="perk-list">
                                    {item.perks.map((perk, i) => (
                                        <li key={i}><IoCheckmarkOutline className="check-icon" /> {perk}</li>
                                    ))}
                                </ul>
                            </div>
                            {/* CHANGED: Passing item.license_type here */}
                            <button className="choose-btn" onClick={() => { setSelectedLicense(item.license_type); handlePurchase(item.license_type); }}>Choose</button>
                        </div>
                    ))}

                    {/* Contact Card */}
                    <div className="license-card contact-card">
                        <div className="card-title">
                            <strong>All substances</strong> <span className="green-text">/ All endpoints</span>
                        </div>

                        <div className='perk-container'>
                            <ul className="perk-list">
                                <li><IoCheckmarkOutline className="check-icon" /> Test as many nanoforms as you want</li>
                                <li><IoCheckmarkOutline className="check-icon" /> Pick from all available endpoints</li>
                            </ul>

                        </div>
                        <div className="contact-info">
                            <p><strong>Contact us to know the price!</strong></p>
                            <p>+77 876 555 676, <a href="mailto:nqtb@qsarlab.com">nqtb@qsarlab.com</a></p>
                        </div>
                    </div>
                </div>

                <div className="table-container">
                    <table className="license-table">
                        <thead>
                            {/* CHANGED: Updated table headers to match new backend data */}
                            <tr>
                                <th onClick={() => handleSort('license_name')}>License</th>
                                <th onClick={() => handleSort('amount')}>Price</th>
                                <th onClick={() => handleSort('created')}>Purchased</th>
                                <th onClick={() => handleSort('status')}>Status</th>
                                <th>Invoice</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* CHANGED: Switched to real sortedPayments, added loading state */}
                            {histLoading ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '2rem' }}>
                                        <HashLoader size={30} color="#000" style={{ margin: '0 auto' }} />
                                    </td>
                                </tr>
                            ) : sortedPayments.length > 0 ? (
                                sortedPayments.map((payment) => {
                                    // Split the "Name / Sub" string we get from Stripe
                                    const nameParts = payment.license_name ? payment.license_name.split('/') : ['Unknown', ''];
                                    
                                    return (
                                        <tr key={payment.id} className={payment.status === 'Paid' ? 'active-row' : ''}>
                                            <td>
                                                {payment.status === 'Paid' && <div className="green-flag"></div>}
                                                <strong>{nameParts[0].trim()}</strong><br />
                                                <span className="sub-text">{nameParts[1] ? nameParts[1].trim() : ''}</span>
                                            </td>
                                            <td>{payment.amount} {payment.currency.toUpperCase()}</td>
                                            <td>{payment.created}</td>
                                            <td>
                                                <span className={`badge ${payment.status.toLowerCase()}`}>
                                                    {payment.status}
                                                </span>
                                            </td>
                                            <td>
                                                {payment.invoice_url ? (
                                                    <a href={payment.invoice_url} target="_blank" rel="noopener noreferrer" style={{color: '#555'}}>
                                                        <FontAwesomeIcon icon={faFileInvoiceDollar} size="lg" />
                                                    </a>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center' }}>No payments found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </main>
    );
};

export default WalletContent;